import { render } from "./SingleChipSelection.vue?vue&type=template&id=3a4c5726&scoped=true&ts=true"
import script from "./SingleChipSelection.vue?vue&type=script&lang=ts"
export * from "./SingleChipSelection.vue?vue&type=script&lang=ts"

import _style_0 from "./SingleChipSelection.vue?vue&type=style&index=0&id=3a4c5726&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-3a4c5726"]])

export default __exports__